export const GUINCHO_TRASEIRO_3PONTO = {
    Codigo: 10,
    Nome: 'Guincho Traseiro 3º Ponto',
    Modelo: 'GH-1000',
    Capa: null, 
    Imagens: [
        {
            Capa: true,
            Ativo: true,
            Url: "assets/IPB/Produtos/Guincho_Traseiro_3Ponto/guincho_3p_1.png"
        },
        {
            Url: "assets/IPB/Produtos/Guincho_Traseiro_3Ponto/guincho_gh1000_1.png"
        }
    ],
    Detalhes: [
        `Guincho traseiro 3º ponto`,
        `GH-800:`,
        ` - Capacidade 800Kg`,
        ` - Altura de levante 3m`,
        `GH-1000:`,
        ` - Capacidade 1000Kg`,
        ` - Altura de levante: 4m`
    ],
    Modelos: [
        { Modelo: 'GH-800', Detalhes:	'800 kg' },
        { Modelo: 'GH-1000', Detalhes:	`1000 kg` }
    ]
}